import React, { useState } from "react";
import "./Ordertextfield.scss";
import moment from "moment/moment";
import { useTranslation } from "react-i18next";
import {
  FormControl,
  InputLabel,
  Select,
  Checkbox,
  ListItemText,
  MenuItem,
  Button,
} from "@mui/material";

const PartsOrderTextField = ({
  filterSearch,
  searchInput,
  options,
  selectedStatusOptions = [],
  fromDate,
  toDate,
  handleSearchInputChange
}) => {
  const { i18n, t } = useTranslation();
  const From_date = fromDate === "" ? "" : moment().format(fromDate, "YYYY MMMM Do");
  const To_date = toDate === "" ? "" : moment().format(toDate, "YYYY MMMM Do");

  const isSearchFieldDisabled = () => {
    return (
      !searchInput &&
      (!fromDate || !toDate) &&
      selectedStatusOptions?.length === 0
    );
  };

  return (
    <div>
      <div className="pgmtextfield_textfieldcontainers part_order_textfield">
        <div className="order-date-filter">
          <div className="parts_textfield_dropdown">
            <div class="input-wrapper">
              <label for="search">{t('partorderlist.fromdate')}</label>
              <input
                type="date"
                placeholder="DD/MM/YYYY"
                value={fromDate}
                onChange={(event) => handleSearchInputChange(event, "from_date")}
                max={toDate ? toDate : new Date().toISOString().split("T")[0]} // Set max attribute to current date
              />
            </div>
          </div>
          <div className="parts_textfield_dropdown">
            <div class="input-wrapper">
              <label for="search">{t('partorderlist.todate')}</label>
              <input
                type="date"
                value={toDate}
                onChange={(event) => handleSearchInputChange(event, "to_date")}
                placeholder="DD/MM/YYYY"
                max={new Date().toISOString().split("T")[0]} // Set max attribute to current date
                min={fromDate}
              />
            </div>
          </div>
        </div>

        <div className="multiSelect_orderlist">
          <FormControl className="multiselect_orderstatus">
            <InputLabel className="part_orderlist_dropdown_label" htmlFor="multiple-select">
              {t('partorderlist.selectstatus')}
            </InputLabel>
            <Select
              className="multipleselect_order"
              labelId="multi-select-dropdown-label"
              placeholder="Select status"
              id="multi-select-dropdown"
              multiple
              inputProps={{ className: "multiselect_orderinput" }}
              value={selectedStatusOptions || []}
              onChange={(event) => handleSearchInputChange(event, "statusValue")}
              renderValue={(selected) => {
                const translatedOptions = selected.map((value) => t(options.find((opt) => opt.value === value)?.label));
                return translatedOptions.join(", ");
              }}
            >
              {options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  <Checkbox
                    checked={selectedStatusOptions?.indexOf(option.value) > -1}
                  />
                  <ListItemText primary={t(option.label)} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className="partsorderfield_dropdown">
          <div class="input-wrapper">
            <label for="search">{t('partlist.search')}</label>
            <input
              type="text"
              className="search_partorderlist buttonsearch"
              name="searchInput"
              value={searchInput}
              onChange={(event) => handleSearchInputChange(event, "searchdata")}
              placeholder={t('partorderlist.searchordernoname')}
            />
          </div>
        </div>
        <button
          className="button_search-pgmlist"
          disabled={isSearchFieldDisabled()}
          onClick={() =>
            filterSearch(From_date, To_date, searchInput, selectedStatusOptions)
          }
        >
          {t('partlist.search')}
        </button>
      </div>
    </div>
  );
};

export default PartsOrderTextField;
